/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ChartDataLabels from 'chartjs-plugin-datalabels';


Chart.register(...registerables, annotationPlugin, ChartDataLabels);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
